import React from 'react'
import { Tooltip, Button } from 'antd';

/** Расчитывает необхъодимость ширины окна с UML диаграммой.
 * Определяет по количеству дочерних элементов
 */
const calculateModalWidth = record => {
  if (record && Array.isArray(record.children)){
    if (record.children.length > 9) return "100%";
    if (record.children.length > 4) return "75%";
    if (record.children.length > 3) return "50%";
  }
  return undefined;
}

class EMDTableColumnAction extends React.Component {

  constructor(props) {
    super(props);
    this.onAction = this.onAction.bind(this);
  }

  onAction (e, record, text, modalWidth=undefined) {
    e.preventDefault();
    const {onAction} = this.props;
    if (onAction) onAction(record, text, modalWidth);
  }

  render() {
    //console.log(this);
    const {value, row} = this.props;
    return (
      <span>
        {row.class && (
          <Tooltip title="UML диаграмма">
            <Button size="small" onClick={(e)=> {this.onAction(e, row, "UML", calculateModalWidth(row))}}>UML</Button>
          </Tooltip>)}
        {'\u00A0'}
        {row.class && (    
          <Tooltip title="XSD файл">
            <Button size="small" onClick={(e)=> {this.onAction(e, row, "XSD")}}>XSD</Button>
          </Tooltip>)}
        {'\u00A0'}
        <Tooltip title="Информация об элементе полученная в ходе коллективной работы.">
          <Button size="small" onClick={(e)=> {this.onAction(e, row, "CLM")}}>CLM</Button>
        </Tooltip>
      </span>
    );
  }
}

export default EMDTableColumnAction;